
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/savings",
      function () {
        return require("private-next-pages/account/savings/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/savings"])
      });
    }
  